const NameSpace = {
    DATA: `DATA`,
};

export default NameSpace;